export const PLAYER_AUDIO_KEY = 'bigplays:playerAudio';

export function clampGain(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 1;
  return Math.min(1, Math.max(0, x));
}

export function readPlayerAudioMap() {
  try {
    const raw = JSON.parse(localStorage.getItem(PLAYER_AUDIO_KEY) || '{}');
    if (!raw || typeof raw !== 'object') return {};
    const out = {};
    Object.entries(raw).forEach(([id, rec]) => {
      out[id] = {
        volume: clampGain(rec?.volume),
        muted: !!rec?.muted
      };
    });
    return out;
  } catch {
    return {};
  }
}

export function writePlayerAudioMap(map) {
  try {
    localStorage.setItem(PLAYER_AUDIO_KEY, JSON.stringify(map));
  } catch {
    // Ignore quota / private-mode failures; in-memory state still works.
  }
}

export function getPlayerAudioPref(map, id) {
  const rec = map?.[String(id)];
  return {
    volume: rec ? clampGain(rec.volume) : 1,
    muted: !!rec?.muted
  };
}

export function patchPlayerAudio(map, id, patch) {
  const key = String(id);
  const next = {
    ...map,
    [key]: { ...getPlayerAudioPref(map, key), ...patch }
  };
  writePlayerAudioMap(next);
  return next;
}
